import { useT } from "../i18n";
import { Knopf } from "./index";
import { istNachtraeglichFrage } from "../daten/nachtraeglich";

/**
 * Der Knopf unter der Rückfrage „Der Mietbeginn liegt in der Vergangenheit —
 * nachträglich erfassen?" (Interview F20, `daten/nachtraeglich.ts`).
 *
 * Der Satz selbst steht dort, wo die Maske ihre Fehler zeigt; hier steht nur,
 * was es dazu braucht: „Ja, nachträglich erfassen". Bei jedem anderen Fehler
 * steht nichts.
 */
export function Nachtraeglichfrage({ fehler, ja, laeuft }: {
  fehler: unknown;
  /** Schickt dieselbe Anfrage mit `nachtraeglich: true`. */
  ja: () => void;
  laeuft?: boolean;
}) {
  const t = useT();
  if (!istNachtraeglichFrage(fehler)) return null;
  return (
    <p className="blatt-satz">
      <Knopf klein einmal disabled={laeuft} onClick={ja}>{t("nachtraeglich.ja")}</Knopf>
    </p>
  );
}
